import { KybComplianceDetail } from "../types";

export const KYB_COMPLIANCE_DETAILS: Record<string, KybComplianceDetail> = {
  "marie-curie": {
    id: "marie-curie",
    customerName: "HMA Logistics",
    customerEmail: "hello@bl.com",
    businessName: "HMA Logistics",
    businessType: "LLC",
    pendingDocuments: 4,
    approvedDocuments: 5,
    rejectedDocuments: 1,
    country: "Nigeria",
    registrationDate: "Jul 1, 2025",
    status: "under-review",
    statusLabel: "Under review",
    registeredContact: "Marie Curie",
    phoneNumber: "091 321 654 8901",
    phoneVerified: true,
    rcNumber: "012345",
    webPresence: "bl.com",
    registeredAddress: "2323 S. Shepherd #1300, Houston, Texas, U...",
    physicalAddress: "2323 S. Shepherd #1300, Houston, Texas, U...",
    natureOfBusiness: "Trucking & Haulage services",
    isHighRisk: true,
    highRiskActivities: ["Cryptocurrency", "Gambling", "Adult"],
    wallets: ["USD", "EUR"],
    proofOfAddressType: "Utility bill",
    transactionVolume: "NGN 100,000,000 volume",
    sourceOfFunds: "Sales of goods and services",
    directors: [],
    ubos: [],
    kycRequirements: [],
  },
  "rosalind-franklin": {
    id: "rosalind-franklin",
    customerName: "Line Experts",
    customerEmail: "rosalind@line-experts.com",
    businessName: "Line Experts",
    businessType: "Sole Trader/Partnership",
    pendingDocuments: 2,
    approvedDocuments: 8,
    rejectedDocuments: 1,
    country: "UK",
    registrationDate: "Oct 30, 2025",
    status: "started",
    statusLabel: "Started",
    registeredContact: "Rosalind Franklin",
    phoneNumber: "0712 456 8890",
    phoneVerified: true,
    rcNumber: "998821",
    webPresence: "line-experts.com",
    registeredAddress: "18 St. Martin Lane, London, WC2N...",
    physicalAddress: "18 St. Martin Lane, London, WC2N...",
    natureOfBusiness: "Freight coordination and customs brokerage",
    isHighRisk: false,
    highRiskActivities: [],
    wallets: ["GBP", "USD"],
    proofOfAddressType: "Bank statement",
    transactionVolume: "GBP 75,000 volume",
    sourceOfFunds: "Business revenue",
    directors: [],
    ubos: [],
    kycRequirements: [],
  },
};
